import {
  showRecoveryPasswordNotification,
  changePasswordPanel,
  createCarrusel,
  createSwiper,
  scrollUp,
  detectIEEdge,
  convertToArray,
  lazyLoad,
  lazyLoadIE,
  oTrackingEvents,
} from "./lib/Utils";
import { getPublicUserTemplate } from "./login";
("./login");
import "./listing";

window.oTrackingEvents = oTrackingEvents;

window.addEventListener("load", function () {
  const lazyTargets = document.querySelectorAll(".lazy-loading");
  if (detectIEEdge()) {
    aImages = convertToArray(lazyTargets);
    aImages.forEach(lazyLoadIE);
  } else {
    lazyTargets.forEach(lazyLoad);
  }

  showRecoveryPasswordNotification();
  changePasswordPanel();
  createSwiper();
  scrollUp();
  createCarrusel();
  getPublicUserTemplate();
});
